const rulesConfig = {
    required: {
        value: true,
        message: 'Obowiązkowe pole',
    },
    minLength: {
        value: 8,
        message: 'Pole musi mieć przynajmniej 8 znaków',
    },
    passwordMinLength: {
        value: 8,
        minLength: 8,
        message: 'POLE MUSI MIEĆ PRZYNAJMNIEJ 8 ZNAKÓW',
    },
    maxLength: {
        value: 32,
        message: 'Za długie',
    },
    email: {
        value: /S+@S+.S+/,
        message: 'Niepoprawny adres email',
    },
    validate: {
        message: 'Różne hasła',
    },
    date: {
        message: 'Niepoprawny format daty',
    },
};

export default rulesConfig;
